import { useEffect, useMemo, useState } from 'react';
import { getBusinessTodayDate, getEpisodeDateBounds } from '../utils/dateUtils';

/**
 * DatePicker bounds for logging a patient event within an episode, using the
 * agency's business date as "today" so the picker never offers a
 * date the backend rejects as future.
 *
 * `today` is refreshed each time the dialog opens — dialogs stay mounted
 * across days, so a mount-time date would go stale past midnight.
 */
export function useEpisodeDateBounds(
  open: boolean,
  episodeStartDate?: string | null,
  episodeEndDate?: string | null
): { minDate: Date | undefined; maxDate: Date; today: Date } {
  const [today, setToday] = useState(() => getBusinessTodayDate());
  useEffect(() => {
    if (open) setToday(getBusinessTodayDate());
  }, [open]);
  return useMemo(
    () => ({
      ...getEpisodeDateBounds(episodeStartDate, episodeEndDate, today),
      today,
    }),
    [episodeStartDate, episodeEndDate, today]
  );
}
